<!-- Filename: app.component.html -->
<!-- Shell-Komponente für Angular Routing – zeigt Router-Content und die
     app-weiten Overlays. Das Popup gehört hierher und nicht in eine Seite:
     eine Nachricht erreicht den Nutzer auch dann, wenn er gerade im
     Task-Editor oder im Daily Scrum arbeitet. -->

<router-outlet></router-outlet>

<app-message-popup></app-message-popup>

<!-- Anfrage per @ (Alt+P) und die wiederkehrende Erinnerung — _40 #223.
     Nicht auf den Anmeldeseiten: dort gibt es noch keine Sitzung. -->
@if (mitAnfragen()) {
  <app-ask-panel></app-ask-panel>
  <app-request-reminder></app-request-reminder>
  <!-- Eisenhower-Fenster (Alt+N): was ich jetzt tun, planen, delegieren, lassen soll — 23.10.2026 -->
  <app-eisenhower-panel></app-eisenhower-panel>
  <!-- KI-Agent-Statusanzeige: Ampel je Agent unten rechts, nur auf Projektseiten — 02.11.2026 -->
  <app-agent-status></app-agent-status>
}
